import axios, { AxiosResponse } from 'axios';

import { getDefaultConfig } from '../config/utils';
import { PspConnector, RetryPaymentStatus } from '../types';

export const initiateCreditCardPayment = async ({
  csrfToken,
  ...payload
}: {
  csrfToken: string;
  paymentAmount: number;
  paymentMethodNonce?: string;
  orderId: string;
  siteId: number;
  currency: string;
  connector: PspConnector;
  deviceData?: string;
}) => {
  const { initiatePaymentBaseUrl } = getDefaultConfig();

  const response: AxiosResponse<RetryPaymentStatus> = await axios({
    method: 'post',
    url: `${initiatePaymentBaseUrl}/payments`,
    headers: { 'X-CSRF-Token': csrfToken }, // 'X-Original-Host': domain
    data: JSON.stringify({ ...payload, paymentMethod: 'CREDIT_CARD' }),
  });
  return response;
};

export const initiatePaypalPayment = async ({
  csrfToken,
  paymentAmount,
  ...payload
}: {
  csrfToken: string;
  tokenId: string;
  paymentAmount: number;
  orderId: string;
  siteId: number;
  currency: string;
}) => {
  const { initiatePaymentBaseUrl } = getDefaultConfig();
  const response: AxiosResponse<RetryPaymentStatus> = await axios({
    method: 'post',
    url: `${initiatePaymentBaseUrl}/payments`,
    headers: { 'X-CSRF-Token': csrfToken }, // 'X-Original-Host': domain
    data: JSON.stringify({
      ...payload,
      paymentAmount: paymentAmount.toFixed(2).toString().replace('.', ''),
      paymentMethod: 'PAYPAL',
    }),
  });
  return response;
};
